module.exports = __webpack_public_path__ + "static/media/fillshare-weekday.7c92b8e4.png";